<template>

<div class="divTable">
      <!-- Titre du sous menu -->
      <div  v-bind:class="backgroundColor"  class="divCellLeft hidden-xs-only">
        <div class="rotate">{{column.leftTitle}}</div>
      </div>
      <div   class="divCellTop hidden-sm-and-up">
        <div v-bind:class="backgroundColor" class="border-r" >{{column.leftTitle}}</div>
      </div>

      <!-- -->
      <div  class="divCell" >
        <el-row ><el-col>
        <table  class="table" >
          <tr v-bind:class="backgroundColorTd" >
            <td class="border-l width-td-md" v-bind:class="borderR" >
              <div v-for="(value,index) in column.col01" :key="index">            
                <span v-if="index!='title'"><b> {{value}}</b> </span>
                <span v-else> {{value}}</span>         
              </div>
            </td>
            <td class=" hidden-sm-and-down width-td-md" v-bind:class="borderR">
              <div v-for="(value,index) in column.col02" :key="index">
                <span v-if="index!='title'"><b> {{value}}</b> </span>
                <span v-else>{{value}}</span>  
              </div>
            </td>
            <td class=" hidden-sm-and-down width-td-md">
              <div v-for="(value,index) in column.col03" :key="index">
                  <span v-if="index!='title'"><b> {{value}}</b> </span>
                  <span v-else>{{value}}</span>  
              </div>
            </td>
          </tr>
          <tr v-bind:class="backgroundColorTd" class="hidden-md-and-up">
            <td  class="border-l" >
              <div v-for="(value,index) in column.col02" :key="index">
                 <span v-if="index!='title'"><b> {{value}}</b> </span>
                <span v-else>{{value}}</span>  
              </div>
            </td>
          </tr>
		      <tr v-bind:class="backgroundColorTd" class="hidden-md-and-up">
 			      <td  class="border-l">
              <div v-for="(value,index) in column.col03" :key="index">
                 <span v-if="index!='title'"><b> {{value}}</b> </span>
                  <span v-else>{{value}}</span>  
              </div>
            </td>
		      </tr>
        </table>
        </el-col></el-row >
      </div>
    </div>
</template>
<script>

import CheckupDetail from '@/components/checkup.detail.component.vue'

export default {
  name: 'checkupTab',
  props: ['column','parameters'],
  components: {
    CheckupDetail
  },
  

  computed: {
		backgroundColor() {
			return this.parameters.classColor;
		},
      backgroundColorTd() {
        return this.parameters.classColor+"-td";
      },
      borderL() {
        return this.parameters.borderLeft;
      },
      borderR() {
        return this.parameters.borderRight;
      }
  }
};

</script>

<style scoped>

table span {
  padding-left: 10px;
};



  @media only screen and (max-width: 992px) {
    .border-r{
      border-right-style: none;
      border-bottom-width: 6px;
      border-bottom-style: solid;
      border-color: white;
    }
  }

  @media only screen and (max-width: 767px) {   
    .border-l{
      border-left-style: none;
    }
  }




</style>
